import { BareActionContext } from 'vuex-typex'
import { ConvoState } from '../state'
import { RootState } from '../..'
import convoStore from '../convo-store'
import authStore from '../../auth/auth-store'
import setConvoQuery from './set-convo-query'
import { IUser } from '../../../model/user'
import feedStore from '../../feed/feed-store'

export default async function toggleLikedByUser(context: BareActionContext<ConvoState, RootState>)
{
  const form = convoStore.state.convoSearchForm
  if (!feedStore.isCurrentUser && !form.likedByUser) {
    form.createdByUser = true
  }

  setConvoQuery(context)

  return
}
